import { CommentRollerComponent } from './../../components/online-design/comment-roller/comment-roller.component';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolicyComponent } from '../../components/online-design/policy/policy.component';
import { ArchEscortComponent } from '../../components/online-design/arch-escort/arch-escort.component';
import { HeaderMobileComponent } from '../../components/online-design/online-header/header-mobile/header-mobile.component';
import { ShareThisComponent } from '../../components/online-design/online-header/share-this/share-this.component';
import { OnlineHeaderComponent } from '../../components/online-design/online-header/online-header.component';
import { TitleComponent } from '../../components/online-design/title/title.component';
import { OnlineAskUsComponent } from '../../components/online-design/online-ask-us/online-ask-us.component';
import { SideBarComponent } from '../../components/online-design/side-bar/side-bar.component';
import { UploadFilesComponent } from '../../components/online-design/online-basket/upload-files/upload-files.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatIconModule } from '@angular/material/icon';
import { RecaptchaModule } from 'ng-recaptcha';
import { OnlineErrorOverloadComponent } from '../../components/online-design/online-error-overload/online-error-overload.component';
import { ExecCouponComponent } from '../../components/online-design/coupons/exec-coupon/exec-coupon.component';
import { CreateCouponCodeComponent } from '../../components/online-design/coupons/create-coupon-code/create-coupon-code.component';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {

  faShoppingCart,
  faStar,
  faStarHalf, faArrowCircleRight,
  faArrowCircleLeft,
  faFilePdf,
  faCommentAlt,
  faPrint,
  faLink,
  faEnvelope,
  faEllipsisH,
  faMinus, faBars, faShoppingBasket, faAngleDown, faAngleUp, faComment, faPhoneSlash, faPhoneSquare, faQuestion, faSearch, faCheck, fas
} from '@fortawesome/free-solid-svg-icons';
import {
  faTwitter, faFacebookF, faGooglePlusG, faLinkedinIn,
  faPinterestP, faWhatsapp, faTelegramPlane, faFacebookMessenger, faInstagramSquare, faFacebookSquare, faInstagram
} from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { ChatBotInnerComponent } from '../../components/online-design/chatbot/chat-bot-inner/chat-bot-inner.component';
import { ChatbotComponent } from '../../components/online-design/chatbot/chatbot.component';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { DayLeftPipe } from '../../shared/day-left';
import { ParseJson } from '../../shared/parse-json';
import { StringToUrlPipe } from '../../shared/string-to-url.pipe';
import { CouponBtnComponent } from '../../components/online-design/coupons/coupon-btn/coupon-btn.component';
import { MatButtonModule } from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';


const config: SocketIoConfig = { url: 'https://frozen-reef-94597.herokuapp.com/', options: {} };
const routes: Routes = [
  { path: 'conn/:id', component: ChatbotComponent },

];

@NgModule({
  declarations: [
    DayLeftPipe,
    ParseJson,
    StringToUrlPipe,
    PolicyComponent, ArchEscortComponent,
    HeaderMobileComponent,
    ShareThisComponent,
    OnlineHeaderComponent,
    TitleComponent,
    OnlineAskUsComponent,
    SideBarComponent,
    UploadFilesComponent,
    OnlineErrorOverloadComponent,
    ExecCouponComponent,
    CreateCouponCodeComponent, ChatbotComponent,
    ChatBotInnerComponent, CouponBtnComponent,
    CommentRollerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    FontAwesomeModule,
    AngularEditorModule,
    MatButtonModule, MatCheckboxModule,
    MatIconModule,
    MatInputModule, RecaptchaModule,
    SocketIoModule.forRoot(config),
    MatProgressBarModule
  ],
  exports: [PolicyComponent, ArchEscortComponent,
    HeaderMobileComponent,
    ShareThisComponent,
    OnlineHeaderComponent,
    TitleComponent,
    OnlineAskUsComponent,
    SideBarComponent,
    UploadFilesComponent,
    OnlineErrorOverloadComponent,
    ExecCouponComponent,
    CreateCouponCodeComponent,
    CouponBtnComponent,
    ChatbotComponent,
    ChatBotInnerComponent,
    DayLeftPipe,
    ParseJson,
    StringToUrlPipe,
    MatProgressBarModule,
    CommentRollerComponent
  ]
})
export class ShareModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
    library.addIconPacks(far);
    library.addIcons(
      faShoppingCart, faStar, faArrowCircleRight,
      faArrowCircleLeft, faFilePdf, faFacebookF, faTwitter,
      faGooglePlusG, faLinkedinIn, faPinterestP, faWhatsapp,
      faFacebookMessenger, faTelegramPlane, faCommentAlt,
      faEnvelope, faLink, faPrint, faStarHalf,
      faEllipsisH, faMinus, faBars, faShoppingBasket,
      faAngleDown, faAngleUp, faComment, faPhoneSquare,
      faQuestion, faSearch, faCheck, faInstagramSquare,
      faFacebookSquare,faInstagram
    );
  }
  static forRoot(): ModuleWithProviders<ShareModule> {
    return {
      ngModule: ShareModule,
      providers: []
    }
  }
}
